export default "__VITE_ASSET__u3hzV$XOpaPyVgNN09EB7Q__"